import locationAnalyticsTemplate from './locationAnalytics.html';
import './locationAnalytics.scss';

export default angular
  .module('main.locations.edit.components.analytics', [])

  /**
   * Location analytics textarea with autosave feature
   */
  .directive('editLocationAnalytics', () => {
    return {
      restrict: 'E',
      template: locationAnalyticsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        angular.extend($scope, {});

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationCardsResource.init(),
            $scope.dataProvider.locationTrendsResource.init()
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });

          $scope.$watch('dataProvider.locationCardsResource.value', () => {
            initViewModel();
          }, true);

          $scope.$watch('dataProvider.locationTrendsResource.value', () => {
            initViewModel();
          }, true);
        }

        function initViewModel() {
          $scope.cards = angular.copy($scope.dataProvider.locationCardsResource.value);
          $scope.trends = angular.copy($scope.dataProvider.locationTrendsResource.value);
        }
      }
    };
  })
  .name;
